// style do titulo do card
export const cardTitleStyle = {
    fontSize: '1.2rem',
    fontWeight: 'bold',
};

export const cardStyle = {
    marginBottom: '20px',
    cursor: 'pointer',
    transition: 'transform 0.2s',
};